import { ClienteLogin, Cliente, ClienteVAM } from "../../../views/login/cliente_login";
import { HandleError } from "./handleError.component";
import { SessionTokenService } from "./sessionToken.service";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { Injectable } from '@angular/core';
import { CabeceraVamTitularService } from "../cabeceraVAMTitulares/cabecera-vam-titulares.service";
import { PolizaEntity } from "../../../views/empresas/entities/polizas_cliente_entity";
import { VamTitularEntity } from "../../../views/vam/titulares/entities/vam_titulares_entity";

declare var jQuery: any;

@Injectable()
export class ConsultarUsuarioVAM {
    usuario: ClienteLogin;
    userAUsar: ClienteVAM;
    bandera: boolean;
    maxDateValue: Date;
    minDateValue: Date;
    yearRange: string;
    @SessionStorage("uservam")
    userVAM: any;
    vamTitular: VamTitularEntity;

    constructor(private sesionStorageService: SessionStorageService, 
        private handleError: HandleError,
        private sessionTokenService: SessionTokenService,
        private cabeceraVamService: CabeceraVamTitularService) {
            this.vamTitular = new VamTitularEntity();
    }
    iniciarUsuarioVAM():void{
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.consultaTodo();
        this.sesionStorageService.observe("usuario").subscribe(v => {
            this.usuario = jQuery.parseJSON(v);
            this.consultaTodo();
        });
    }

    consultaTodo(){
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        }
        this.sessionTokenService.useJwtHelper();
        let usuarioVAM = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
        if(usuarioVAM == null){
            this.consularIfUsuarioVAM();
        }
        this.sesionStorageService.observe("uservam").subscribe(v=>{
            let usuarioVAM1 = jQuery.parseJSON(v);
            if(usuarioVAM1 == null && usuarioVAM1 == undefined){
                this.consularIfUsuarioVAM();
            }
        });
        this.vamTitular.Cedula = this.usuario.Cedula;
        this.consultarNombreTitular(this.vamTitular);
    }
    consularIfUsuarioVAM(){
        if (this.usuario != null) {
                if (this.usuario.VAM != null) {
                    this.userVAM = JSON.stringify(this.usuario.VAM[0]);
                    this.sesionStorageService.store("uservam",JSON.stringify(this.usuario.VAM[0]));
                } else {
                    let error = { "status": 998, "message": "Acceso denegado" };
                    this.handleError.redirectUrl(error)
                }
            } else {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            }
    }

    consultarNombreTitular(vamTit: VamTitularEntity){
        this.cabeceraVamService.consultaSegurosContratados(vamTit).subscribe(
            result => {
                this.sesionStorageService.store("nombreuser",result.PrimerNombre + " " + result.SegundoNombre + " " + result.ApellidoPaterno + " " + result.ApellidoMaterno);
            },
            error => {
                this.handleError.redirectUrl(error)
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/consultarUsuarioVAM.ts